<script setup lang="ts">
import { NewProduct } from '@/types/api/api-v4/product'
import { ProductDetailType } from '@/types/components/product-card.types'

import ProductDetailCard from '@/components/Product/ProductDetail/ProductDetailCard.vue'

const ProductDetailPricePanel = defineAsyncComponent(
  () =>
    import('@/components/Product/ProductDetail/ProductDetailPricePanel.vue'),
)

type Props = {
  products: NewProduct[]
  product: NewProduct
}

const props = defineProps<Props>()

const { isMobile } = useResponsive()

/* текущая модификация товара */
const currentModification = ref(props.product?.modifications[0] || null)

const changeModification = (modificationId: number) => {
  // меняем текущую модификацию продукта путем поиска по id модификации
  currentModification.value =
    props.product.modifications.find(
      (modification) => modification.id === modificationId,
    ) ||
    props.product.modifications[0] ||
    null
}
</script>

<template>
  <div class="product-dialog-content">
    <div class="product-dialog-content__product-detail">
      <div class="product-dialog-content__product-card">
        <product-detail-card
          :type="ProductDetailType.Page"
          :product="product"
          :current-modification="currentModification"
          @update:current-modification="changeModification"
        />
      </div>
    </div>

    <product-detail-price-panel
      v-if="isMobile"
      :current-modification="currentModification"
    />
  </div>
</template>

<style lang="scss" scoped>
.product-dialog-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  @include media('>=tablet') {
    // TODO Крестик в модалке скрывается под блоком на планшете, убрать после фикса
    padding-top: 2px;
  }

  &__product-detail {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  &__product-card {
    width: 100%;
    padding: 12px 16px 24px;
    background-color: var(--ui-white);

    &:not(:last-child) {
      margin-bottom: 16px;
      border-radius: 0 0 20px 20px;
    }

    &:last-child {
      padding-bottom: 24px;
    }

    @include media('>=tablet') {
      padding: 0 !important;
    }
  }
}
</style>
